export default "__VITE_ASSET__cyhcHrVF__"